import {
  Row,
  Col,
  Label,
  InputField,
  PrimaryButton,
  PopupDialogbox,
  OutlineButton,
  Datepicker,
  ReactSelectBox,
} from "client/CommonComponents";
import "./PurchaseOrderDetail.scss";
import CancelConfirmationPopup from "../CancelConfirmationpopup";
import moment from "moment";
import { CONSTANTS } from "client/utils/constants";
import { useMemo } from "react";
import { isAuthorized } from "client/utils/Permissions";
import { FLEET_PROCESSING_PERMISSIONS } from "client/utils/constants/fleetProcessingPermissions";

interface IProps {
  Popupcontent?: any;
  createPOClick?: any;
  hideDialog?: any;
  popupOutlinebtnOnclick?: any;
  handleClickCancel?: any;
  popupPrimarybtnOnclick?: any;
  PopupcontentPool?: any;
  popupOutlinebtnOnclickPool?: any;
  hideDialogPool?: any;
  handleChange?: any;
  onChangeGLAccountCode?: any
  onChangeEqClassCode?: any
  onChangeBarCode?: any;
  onBlurBarcode?: any;
  purchaseOrderStepperData?: any;
  updateValue: Function;
  savePurchaseOrder: Function;
  errors?: any;
  isCompleted?: boolean;
  glAccountCodesDropdownList?: any;
  eqClassCodeDropdownList?: any;
}
const PurchaseOrderDetail = ({
  hideDialogPool,
  popupOutlinebtnOnclickPool,
  PopupcontentPool,
  popupPrimarybtnOnclick,
  handleClickCancel,
  Popupcontent,
  createPOClick,
  hideDialog,
  popupOutlinebtnOnclick,
  handleChange,
  onChangeGLAccountCode,
  onChangeEqClassCode,
  onChangeBarCode,
  onBlurBarcode,
  purchaseOrderStepperData,
  updateValue,
  savePurchaseOrder,
  errors,
  isCompleted,
  glAccountCodesDropdownList,
  eqClassCodeDropdownList,
}: IProps) => {
  const glAccountCodeValue = useMemo(() => {
    return glAccountCodesDropdownList?.find(
      (x: any) => x.value === purchaseOrderStepperData?.glaccountNumber
    );
  }, [purchaseOrderStepperData?.glaccountNumber, glAccountCodesDropdownList]);

  const eqClassCodeValue = useMemo(() => {
    return eqClassCodeDropdownList?.find(
      (x: any) => x.value === purchaseOrderStepperData?.eqClassCode
    );
  }, [purchaseOrderStepperData?.eqClassCode, eqClassCodeDropdownList]);

  const isNonStandardEquipment =
    purchaseOrderStepperData?.orderRequestType === CONSTANTS.NON_STANDARD_EQUIPMENT;

  return (
    <>
      <Row className="border px-0 mx-0">
        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
          <Label data-attribute="PurchaseOrderDetail_Default_Label">PO Receipt Date</Label>
          <div className="date-filter-wrapper">
            <Datepicker
              placeholder="select"
              onChangeDate={(date: any) =>
                updateValue("poReceiptDate", moment(date).toISOString(), null,'isPurchaseOrderSave')
              }
              value={
                purchaseOrderStepperData?.poReceiptDate
                  ? new Date(purchaseOrderStepperData?.poReceiptDate)
                  : null
              }
              allowTextInput={false}
              disabled={purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData.poNumber || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
             data-attribute="PurchaseOrderDetail_Default_Datepicker" />
            {(!purchaseOrderStepperData.poNumber || purchaseOrderStepperData?.itemStatus != CONSTANTS.ORDER_STATUS.CANCELLED || purchaseOrderStepperData?.itemStatus != CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR ) &&
              <i
                className="fa fa-times-circle-o"
                aria-hidden="true"
                onClick={() => updateValue("poReceiptDate", null, null,'isPurchaseOrderSave')}
              ></i>
            }
          </div>
        </Col>
        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
          <Label required data-attribute="PurchaseOrderDetail_Default_Label_2">PO Description 1</Label>
          <InputField
            name="poDescription1"
            value={purchaseOrderStepperData?.poDescription1}
            onChange={(e: any)=>handleChange(e, undefined, purchaseOrderStepperData?.fleetRequestDetailId)}
            className={(errors?.poDescription1 ? "controlValidation" : "")}
            disabled={purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData.poNumber || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
           data-attribute="PurchaseOrderDetail_poDescription1_Input" />
          {errors?.poDescription1 && (
            <span className="validMessage">
              {errors?.poDescription1 === 'length-30'
                ? 'Please enter PO Description 1 less than 30 characters'
                : 'PO Description 1 is required'
              }
            </span>
          )}
        </Col>
        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
          <Label data-attribute="PurchaseOrderDetail_Default_Label_3">PO Description 2</Label>
          <InputField
            name="poDescription2"
            value={purchaseOrderStepperData?.poDescription2}
            onChange={handleChange}
            className={(errors?.poDescription2 ? "controlValidation" : "")}
            disabled={purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData.poNumber || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
           data-attribute="PurchaseOrderDetail_poDescription2_Input" />
          {errors?.poDescription2 && (
            <span className="validMessage">
              {errors?.poDescription2 === 'length-30'
                ? 'Please enter PO Description 2 less than 30 characters'
                : 'PO Description 2 is required'
              }
            </span>
          )}
        </Col>
        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
          <Label data-attribute="PurchaseOrderDetail_Default_Label_4">Make</Label>
          <InputField
            name="make"
            value={purchaseOrderStepperData?.make}
            onChange={handleChange}
            disabled={purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData.poNumber || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
           data-attribute="PurchaseOrderDetail_make_Input" />
        </Col>
        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
          <Label data-attribute="PurchaseOrderDetail_Default_Label_5">Model</Label>
          <InputField
            name="model"
            value={purchaseOrderStepperData?.model}
            onChange={handleChange}
            disabled={purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData.poNumber || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
           data-attribute="PurchaseOrderDetail_model_Input" />
        </Col>
        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
          <Label data-attribute="PurchaseOrderDetail_Default_Label_6">Barcode Shipment Tracking#</Label>
          <InputField
            name="barcodeNo"
            value={purchaseOrderStepperData?.barcodeNo}
            onChange={onChangeBarCode}
            className={(errors?.barcodeNo ? "controlValidation" : "")}
            disabled={purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.REQUISITION_COMPLETE || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
           data-attribute="PurchaseOrderDetail_barcodeNo_Input" />
          {errors?.barcodeNo && (
            <span className="validMessage">
              Barcode can't be more than 50.
            </span>
          )}
        </Col>
        <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
          <Label required data-attribute="PurchaseOrderDetail_Default_Label_7">GL Account</Label>
          <ReactSelectBox
            name="glaccountNumber"
            options={glAccountCodesDropdownList}
            value={glAccountCodeValue}
            onChange={onChangeGLAccountCode}
            isSearchable={true}
            className={(errors?.glaccountNumber ? "controlValidation" : "")}
            isDisabled={purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData?.poNumber || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
           data-attribute="PurchaseOrderDetail_glaccountNumber_SearchSelectBox" /> 
          {errors?.glaccountNumber && ( 
            <span className="validMessage">{"Please select GL Account"}</span>
          )}
        </Col>
        {isNonStandardEquipment && (
          <Col xs={12} sm={12} md={4} lg={4} xl={4} className="mb-3">
            <Label data-attribute="PurchaseOrderDetail_Default_Label_8">Eq Class Code</Label>
            <ReactSelectBox
              name="eqClassCode"
              options={eqClassCodeDropdownList}
              value={eqClassCodeValue}
              onChange={onChangeEqClassCode}
              isSearchable={true}
              isClearable={true}
              isDisabled={purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData?.poNumber || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
             data-attribute="PurchaseOrderDetail_eqClassCode_SearchSelectBox" />
          </Col>
        )}
        <div className="PO-number">
          <div className="PO-detail me-2">
            <p>
              <b>PO# : {purchaseOrderStepperData?.poNumber ? purchaseOrderStepperData?.poNumber : ""}</b>
            </p>
            <p>
              {purchaseOrderStepperData?.poCreationDate ? purchaseOrderStepperData?.poCreationDate.replace(/-/g, "/") : ""}
            </p>
          </div>
          <PrimaryButton
            text="Create PO"
            disabled={purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData?.poNumber || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
            className="poolBtn"
            onClick={createPOClick}
           data-attribute="PurchaseOrderDetail_Default_Button" />
          <PopupDialogbox
            hideDialog={!PopupcontentPool.isDialogVisible}
            onDismiss={hideDialogPool}
            Popupcontent={PopupcontentPool}
            popupOutlinebtnOnclick={popupOutlinebtnOnclickPool}
           data-attribute="PurchaseOrderDetail_Default_PopupDilalogBox" />
        </div>
      </Row>
      <div className="vendor-detail-btn">
        <OutlineButton
          text="Save"
          className="pull-right save-vendor"
          onClick={()=>savePurchaseOrder()}
          disabled={purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.RETURNED_TO_REQUESTOR || purchaseOrderStepperData.loading || isCompleted || purchaseOrderStepperData?.itemStatus == CONSTANTS.ORDER_STATUS.CANCELLED || !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.CREATE_UPDATE_PURCHASEORDERS)}
         data-attribute="PurchaseOrderDetail_Default_Button_2"></OutlineButton>
        <OutlineButton
          text="Cancel"
          className="cancel-vendor me-2"
          onClick={handleClickCancel}
         data-attribute="PurchaseOrderDetail_Default_Button_3" />
        <CancelConfirmationPopup
          hideDialog={hideDialog}
          Popupcontent={Popupcontent}
          popupOutlinebtnOnclick={popupOutlinebtnOnclick}
          popupPrimarybtnOnclick={() => popupPrimarybtnOnclick("Home")}
        />
      </div>
    </>
  );
};

export default PurchaseOrderDetail;
